var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-center mt-15"},[_c('div',{staticClass:"error-text"},[_vm._v(" Cant load more items. Please check your "),_c('span',{staticClass:"subscription-link",on:{"click":_vm.openSubscription}},[_vm._v(" subscription ")]),_vm._v(" ! ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }